import { render, staticRenderFns } from "./CtrlRegionWiseAreaChart.vue?vue&type=template&id=dfe8fffe&scoped=true&"
import script from "./CtrlRegionWiseAreaChart.vue?vue&type=script&lang=js&"
export * from "./CtrlRegionWiseAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./CtrlRegionWiseAreaChart.vue?vue&type=style&index=0&id=dfe8fffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe8fffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
